import spell from './spell';
import decos from './decos';
import syno from './syno';
import hanjas from './hanjas';
import dialect from './dialect';
import info from './info';
import searchDeco from './searchDeco';
import blocks from './blocks';
import menu from './menu';
import multilang from './multilangs';
import difficulty from './difficulty';
import report from './report';
import auth from './auth';
import checked from './checked';

import { combineReducers } from 'redux';

const reducers = combineReducers({
	spell,
	decos,
	syno,
	dialect,
	info,
	searchDeco,
	blocks,
	menu,
	hanjas,
	difficulty,
	multilang,
	report,
	auth,
	checked,
});

export default reducers;
